import React from "react";
import styles from "./style.module.css";

import NumberFormat from "react-number-format";
import { Popover, OverlayTrigger } from "react-bootstrap";

import Select from "react-select";

import numeral from "numeral";

export default class RealityWaterfall extends React.PureComponent {
  renderBar(bar, index) {
    const { roundTotal, isRequirementsGathering, showLabel, isCompare } = this.props;

    return (
      <OverlayTrigger
        key={index}
        placement="top"
        trigger={["hover", "focus"]}
        overlay={
          <Popover id="popover-positioned-top" title={bar.label}>
            {bar.tooltip &&
              bar.tooltip.map((tooltip, tIndex) => (
                <div key={tIndex}>
                  {tooltip.value && (
                    <div className={styles.tooltipHolder}>
                      <span className={styles.tooltipInfo}>
                        {bar.tooltipLabel ? bar.tooltipLabel + ": " : "Count: "}
                      </span>
                      <span className={styles.tooltipNumber}>{numeral(tooltip.value).format("0.0a")}</span>
                    </div>
                  )}
                  {tooltip.count && (
                    <div className={styles.tooltipHolder}>
                      <span className={styles.tooltipInfo}>{"Count:"}</span>
                      <span className={styles.tooltipNumber}>{Math.round(tooltip.count)}</span>
                    </div>
                  )}
                </div>
              ))}
          </Popover>
        }
      >
        <div
          className={styles.bar + " " + (isRequirementsGathering ? styles.barMargin : "")}
          style={{
            width: bar.width,
            marginLeft: bar.marginLeft,
            background: bar.color,
            flexGrow: bar.isHidden && 0,
            height: bar.isHidden && "0px"
          }}
        >
          {showLabel ? (
            <div
              className={styles.wLabel}
              style={
                bar.isTotal
                  ? {
                      color: isCompare ? "#333" : "white",
                      marginLeft: isCompare ? "-100px" : "0px"
                    }
                  : { marginLeft: isCompare ? "-100px" : "0px" }
              }
            >
              {bar.label}
            </div>
          ) : (
            <div />
          )}
          {bar.showTotalVal && (
            <div className={styles.barValue}>
              <NumberFormat
                value={roundTotal ? Math.round(bar.value) : bar.value.toFixed(2)}
                displayType={"text"}
                thousandSeparator={true}
              />
            </div>
          )}
        </div>
      </OverlayTrigger>
    );
  }

  renderCompareBar(bar, index) {
    const {
      roundTotal,
      isRequirementsGathering,
      updateViewScenarioIndex,
      updateCompareScenarioIndex,
      compareScenarioIndex,
      viewingScenarioIndex,
      project,
      showLabel,
      isCompare
    } = this.props;

    return (
      <div
        className={styles.compareBar + " " + (isRequirementsGathering ? styles.barMargin : "")}
        style={{
          width: bar.width,
          marginLeft: bar.marginLeft,
          background: "transparent"
        }}
        key={index}
      >
        <OverlayTrigger
          key={index}
          placement="top"
          trigger={["hover", "focus"]}
          overlay={
            <Popover id="popover-positioned-top" title={bar.label}>
              {bar.tooltip &&
                bar.tooltip.map((tooltip, tIndex) => (
                  <div key={tIndex}>
                    {tooltip.value && (
                      <div className={styles.tooltipHolder}>
                        <span className={styles.tooltipInfo}>
                          {bar.tooltipLabel ? bar.tooltipLabel + ": " : "Value: "}
                        </span>
                        <span className={styles.tooltipNumber}>{numeral(tooltip.value).format("0.0a")}</span>
                      </div>
                    )}
                    {tooltip.count && (
                      <div className={styles.tooltipHolder}>
                        <span className={styles.tooltipInfo}>{"Count:"}</span>
                        <span className={styles.tooltipNumber}>{Math.round(tooltip.count)}</span>
                      </div>
                    )}
                  </div>
                ))}
            </Popover>
          }
        >
          <div className={styles.tinyBar} style={{ background: bar.color }}>
            <span
              style={{
                marginLeft: "5px",
                color: bar.width && parseInt(bar.width.replace("%", "")) < 10 ? "black" : "white"
              }}
            >
              {numeral(bar.value).format("0.0a")}
            </span>
          </div>
        </OverlayTrigger>
        {index === 0 || bar.isTotal ? (
          <div className={styles.wLabelSelect}>
            <Select
              options={
                project && project.settings && project.settings.originalScenarios
                  ? project.settings.originalScenarios.map((s, i) => ({
                      label: s.name,
                      value: i
                    }))
                  : []
              }
              value={{
                label: bar.label,
                value: index === 0 ? viewingScenarioIndex : compareScenarioIndex
              }}
              onChange={(val) =>
                index === 0 ? updateViewScenarioIndex(val.value) : updateCompareScenarioIndex(val.value)
              }
            />
          </div>
        ) : (
          <div
            className={styles.wLabelCompare}
            style={
              bar.isTotal
                ? {
                    color: "#333",
                    marginLeft: "-200px"
                  }
                : { marginLeft: "-200px" }
            }
          >
            <div
              className={styles.midIcon}
              style={{
                background: bar.color
              }}
            />
            {bar.label}
          </div>
        )}
      </div>
    );
  }

  renderStackedBar(bar, index) {
    const { isWide, handleOpenDeploy } = this.props;

    return (
      <div key={index} className={styles.barHolder}>
        <div
          className={bar.isSelected ? styles.bSWideLabel : styles.bWideLabel}
          onClick={() => handleOpenDeploy(bar.label)}
        >
          {bar.label}
        </div>
        <OverlayTrigger
          key={index}
          placement="top"
          trigger={["hover", "focus"]}
          overlay={
            <Popover id="popover-positioned-top" title={bar.label}>
              {bar.tooltip &&
                bar.tooltip.map((tooltip, tIndex) => (
                  <div key={tIndex}>
                    {tooltip.value && (
                      <div className={styles.tooltipHolder}>
                        <span className={styles.tooltipInfo}>
                          {bar.tooltipLabel ? bar.tooltipLabel + ": " : "Value: "}
                        </span>
                        <span className={styles.tooltipNumber}>
                          <NumberFormat
                            value={
                              !bar.tooltipLabel && Math.abs(tooltip.value) < 1000
                                ? tooltip.value.toFixed(2)
                                : Math.round(tooltip.value)
                            }
                            displayType={"text"}
                            thousandSeparator={true}
                          />
                        </span>
                      </div>
                    )}
                    {tooltip.count && (
                      <div className={styles.tooltipHolder}>
                        <span className={styles.tooltipInfo}>{"Count:"}</span>
                        <span className={styles.tooltipNumber}>{Math.round(tooltip.count)}</span>
                      </div>
                    )}
                  </div>
                ))}
            </Popover>
          }
        >
          <div className={bar.isSelected ? styles.selectedBHolder : styles.bHolder}>
            <div
              className={styles.realityBar}
              style={{
                width: bar.width,
                marginLeft: isWide ? "35%" : "50%",
                background: bar.value > 0 ? "rgb(146, 207, 72)" : "rgb(235, 51, 43)",
                flexGrow: bar.isHidden && 0,
                overflow: "visible"
              }}
            />
          </div>
        </OverlayTrigger>
      </div>
    );
  }

  render() {
    const {
      bars,
      totalLabel,
      showTotalVal,
      isStacked,
      isWide,
      isCompare,
      useTotal,
      showAbsTotal,
      hideTotal,
      hideLabels,
      isFlex,
      largest
    } = this.props;

    if (bars === undefined) {
      return <div />;
    }

    const colors = ["#92cf48", "#eb332b", "#b1d36f", "#d7a4aa", "var(--aible-color)"];

    let min = undefined;
    let max = undefined;
    let current = 0;

    const maxVal = Math.max.apply(
      Math,
      bars.map((b) => b.value)
    );
    const minVal = Math.min.apply(
      Math,
      bars.map((b) => b.value)
    );

    for (const bar of bars) {
      if (bar.isHidden !== true) {
        current += bar.value;

        if (current < min || min === undefined) {
          min = current;
        }
        if (current > max || max === undefined) {
          max = current;
        }
      }
    }

    if (max > 0 && min > 0) {
      min = 0;
    }

    if (max < 0 && min < 0) {
      max = 0;
    }

    if (isStacked) {
      max = isWide ? 170 : useTotal ? maxVal * 2 : 200;
    }

    if (largest) {
      max = largest;
    }

    let totalDelta = max - min;

    let rBars = [];
    let rCurrent = 0;
    let tCurrent = 0;
    let index = 0;
    let absTotal = 0;

    const pColors = ["rgb(91, 207, 115)", "rgb(91, 207, 115)"];

    const nColors = ["rgb(192, 62, 89)", "rgb(192, 62, 89)"];

    for (const bar of bars) {
      const start = Math.min(rCurrent, rCurrent + bar.value);
      const end = Math.max(rCurrent, rCurrent + bar.value);

      const widthNum = largest === 0 || bar.value === 0 ? 0 : ((end - start) / totalDelta) * 100;

      rBars[index] = {
        ...bar,
        value: bar.value,
        marginLeft: isStacked ? 0 : ((start - min) / totalDelta) * 100 + "%",
        width: largest === 0 || bar.value === 0 ? 0 + "%" : ((end - start) / totalDelta) * 100 + "%",
        mWidth: widthNum + ((start - min) / totalDelta) * 100,
        tooltip: [{ value: bar.value, count: bar.count }],
        color: bar.color
          ? bar.color
          : bar.value > 0
            ? bar.value === maxVal
              ? pColors[0]
              : pColors[1]
            : bar.value === minVal
              ? nColors[0]
              : nColors[1]
      };

      if (bar.isHidden !== true) {
        tCurrent += bar.value;
        absTotal += Math.abs(bar.value);
      }

      rCurrent += bar.value;

      index++;
    }

    const marginLeft =
      tCurrent < 0
        ? (Math.abs(min - tCurrent) / totalDelta) * 100
        : min < 0
          ? (Math.abs(min) / totalDelta) * 100
          : min === 0
            ? 0
            : (Math.abs(min - tCurrent) / totalDelta) * 100;

    if (isStacked !== true && hideTotal !== true) {
      rBars.push({
        value: showAbsTotal ? absTotal : tCurrent,
        marginLeft: marginLeft + "%",
        width: tCurrent === 0 ? "0%" : (((tCurrent < 0 ? 0 : tCurrent) - min) / totalDelta) * 100 - marginLeft + "%",
        color: colors[4],
        label: totalLabel,
        tooltip: [{ value: showAbsTotal ? absTotal : tCurrent }],
        showTotalVal: showTotalVal,
        isTotal: true,
        tooltipLabel: rBars && rBars.length > 0 ? rBars[0].tooltipLabel : undefined
      });
    }

    const retBars = [];

    let rIndex = 0;
    for (const retBar of rBars) {
      retBars.push(
        isStacked
          ? this.renderStackedBar(retBar, rIndex)
          : isCompare
            ? this.renderCompareBar(retBar, rIndex)
            : this.renderBar(retBar, rIndex)
      );

      if (rIndex === 1 || rIndex === 3) {
        retBars.push(
          <div
            key={"ww_" + rIndex}
            style={{
              minHeight: "50px",
              borderLeft: "1px solid rgba(0, 0, 0, 0.2)",
              marginLeft: rIndex === 1 ? retBar.mWidth + "%" : retBar.mWidth + "%"
            }}
          >
            {" "}
          </div>
        );
      }

      rIndex++;
    }

    return (
      <div
        className={
          isCompare ? styles.compareMatrixHolder : isFlex ? styles.flexValueMatrixHolder : styles.valueMatrixHolder
        }
        style={
          isStacked
            ? { background: "transparent", width: "100%" }
            : {
                background: "transparent",
                overflowX: isCompare ? "visible" : "hidden"
              }
        }
      >
        {retBars}
        {min < 0 && !isStacked && (
          <div
            className={styles.zero}
            style={{
              marginLeft: ((0 - min) / totalDelta) * 100 + "%"
            }}
          />
        )}
      </div>
    );
  }
}
